var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.menus && _vm.menus.length)?_c('WpNaviLinks',{attrs:{"menu":_vm.menus,"icons":_vm.icons},on:{"hasActive":_vm.checkChanged}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }